import { Divider } from "native-base";
import React from "react";

const CommonHeaderDivider = (): JSX.Element => <Divider bgColor={"gray.100"} thickness={"0.5"} />;

export default CommonHeaderDivider;
